import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ArrowRightIcon from '../../../icons/arrow-right.svg';
import styles from './NavItem.scss';

export default function NavItem({
    tag: Tag = 'a',
    themeStyles = styles,
    className,
    chevron = true,
    soon = false,
    disabled = false,
    icon: Icon,
    children,
    ...rest
}) {
    return (
        <Tag
            className={classNames(
                themeStyles.root,
                className,
                soon && themeStyles.soon,
                disabled && themeStyles.disabled
            )}
            {...rest}
        >
            {Icon && (
                <span className={themeStyles.icon}>
                    <Icon size={20} />
                </span>
            )}

            <span className={themeStyles.label}>{children}</span>

            {soon ? (
                <i className={themeStyles.badge}>Soon</i>
            ) : chevron === true ? (
                <ArrowRightIcon className={themeStyles.arrow} />
            ) : (
                <div className={themeStyles.chevronData}>
                    {chevron}
                    <ArrowRightIcon className={themeStyles.arrow} />
                </div>
            )}
        </Tag>
    );
}

NavItem.propTypes = {
    tag: PropTypes.elementType,
    className: PropTypes.string,
    soon: PropTypes.bool,
    chevron: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    icon: PropTypes.elementType,
    children: PropTypes.node,
    themeStyles: PropTypes.shape({
        root: PropTypes.string,
        soon: PropTypes.string,
        disabled: PropTypes.string,
        icon: PropTypes.string,
        content: PropTypes.string,
        badge: PropTypes.string,
        arrow: PropTypes.string,
        label: PropTypes.string,
    }),
};

NavItem.styles = styles;
